
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contableregistrogastoComboReducer(state= initialState.contableregistrogastoCombo, action){
	switch(action.type){
		case types.GET_CONTABLEREGISTROGASTOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}